<script lang="ts">

    import type { InfoActivity } from "../../global";
    import AudioPlayer from "../AudioPlayer.svelte";
    import Slide from "../Slide.svelte";
    import Slider from "../Slider.svelte";
    import StartRaceBtn from "../StartRaceBtn.svelte";
    import TopBar from "../TopBar.svelte";

    export let activity: InfoActivity;

    let slider: Slider;
    let contentObserver: MutationObserver;

    function onGalleryImageLoad() {
        slider?.update();
    }

    function registerContentObserver(pageElement: HTMLElement) {
        for (const placeholder of pageElement.querySelectorAll('.comenzar-carrera') as NodeListOf<HTMLElement>) {
            placeholder.style.display = 'flex';
            placeholder.style.justifyContent = 'center';
            new StartRaceBtn({
                target: placeholder
            });
        }
    }

</script>

<style lang="scss">

    .info-activity {
        height: 100%;
        background: linear-gradient(90deg, #022755 0%, #003b83 30%, #003b83 60%, #022755 100%);
    }

    .content {
        padding: 0 1rem 1rem;
        height: calc(100% - 3rem);
        overflow: auto;
        max-width: var(--big-phone-width);
        margin-left: auto;
        margin-right: auto;
        background-color: white;
        box-shadow: -1px 16px 13px 8px rgba(0, 0, 0, 0.27);

    }

    .images {
        min-height: 14rem;
        margin: 0 -1rem 1rem;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .audio-player {
        position: relative;
        z-index: 2;
        margin: 0 -1rem;
    }



</style>

<div class="info-activity">
    <TopBar title={activity.title} on:back />

    <div class="content">
        {#if activity.audio}
        <div class="audio-player">
            <AudioPlayer src={activity.audio} />
        </div>
        {/if}

        <div class="images">
            <Slider bind:this={slider} --height="16rem" pagination={true}>
                {#each activity.images as image}
                <Slide>
                    <img src="{image.url}" alt="" on:load={onGalleryImageLoad}>
                </Slide>
                {/each}
            </Slider>
        </div>

       <div class="page" use:registerContentObserver>{@html activity.text}</div>
    </div>
</div>
